import { FormControl, Textarea } from '@mui/joy';

import { FormLabel } from 'core/elements';

import { IProps } from './Textarea';

const TextareaView = ({ label, tooltip, error, required = false, ...rest }: IProps) => {
  return (
    <FormControl>
      {label && (
        <FormLabel required={required} tooltip={tooltip}>
          {label}
        </FormLabel>
      )}

      <Textarea error={Boolean(error)} {...rest} />
    </FormControl>
  );
};

export default TextareaView;
